export const ZIndex = {
  ScreenOverlay: 50,
  StandardModal: 50,
  InterstitialOverlay: 70,
  Dropdown: 100,
  FloatingTooltip: 200,
  ToastNotification: 500,
};
